var Table = React.createClass({displayName: "Table",
      render: function() {
        return (
        	React.createElement("div", {className: "table-responsive"}, 
        		React.createElement("table", {key: this.props.options.id, id: this.props.options.id, className: this.props.options.tableClass}, 
        			React.createElement(Thead, {data: this.props.options.columns, multiple: this.props.options.multiSelect, dataLength: this.props.options.data.length, styledCheckBox: this.props.options.styledCheckBox}), 
        			React.createElement(Tbody, {rowId: this.props.options.rowId, data: this.props.options.data, emptyData: this.props.options.emptyData, loading: this.props.options.loadingData, error: this.props.options.errorData, columns: this.props.options.columns, multiple: this.props.options.multiSelect, styledCheckBox: this.props.options.styledCheckBox}), 
        			React.createElement(Tfoot, {data: this.props.options.data, columns: this.props.options.columns, rowId: this.props.options.rowId, showFooter: this.props.options.showFooter})
        		)
        	)
        );
      }
    });

var styleCheck;
var Thead = React.createClass({displayName: "Thead",
      
      render: function() {
        styleCheck=!this.props.styledCheckBox;
      	if(this.props.data.length > 0){	
      		var checkboxClass = !this.props.styledCheckBox ? "checkbox checkbox-styled" : "";
	      	var columns = this.props.data.map(function(column){		      	
	      		if(column.source == undefined)
			      	return(
			        	React.createElement("th", {className: "thReact", key: column.dataIndex, name: column.dataIndex}, column.displayName)
			        )
			    else
			    	return(
			        	React.createElement("th", {className: "thReact", key: column.dataIndex, name: column.dataIndex}, 
			        		React.createElement("img", {src: column.source, alt: column.displayName, height: "20", width: "20", tooltips: true, title: column.tooltip})
			        	)
			        ) 
		    })
		    if(this.props.multiple){
		    	if(this.props.dataLength > 0){
		    		return (
			        	React.createElement("thead", null, 
			        		React.createElement("tr", {className: "style-default"}, 
				        		React.createElement("td", {className: "thReact"}, 
				        			React.createElement("div", {className: checkboxClass}, 
				        				React.createElement("label", null, 
				        					React.createElement("input", {className: "checkReady", type: "checkbox", id: "checkAll"}), 
				        					React.createElement("span", {id: "checkAll"})
				        				)
				        			)
				        		), 
			        			columns
			        		)
			        	)
		        	);
		    	}else{
		    		return (
			        	React.createElement("thead", null, 
			        		React.createElement("tr", {className: "style-default"}, 
				        		React.createElement("td", null, 
				        			React.createElement("div", {className: checkboxClass}, 
				        				React.createElement("label", null, 
				        					React.createElement("input", {type: "checkbox", id: "checkAll", disabled: "true"}), 
				        					React.createElement("span", {id: "checkAll"})
				        				)
				        			)
				        		), 
			        			columns
			        		)
			        	)
		        	);
		    	}
	        	
	        }else{
	        	return (
		        	React.createElement("thead", null, 
		        		React.createElement("tr", {className: "style-default"}, 
		        			columns
		        		)
		        	)
	        	);
	        }
        }else{
        	return(
        		React.createElement("thead", null, 
        			React.createElement("tr", null)
        		)
        	)
        }
      }
    });


var Tbody = React.createClass({displayName: "Tbody",
		rawMarkup: function(content){
		    var rawMarkup = marked(content.toString(), {sanizite:true});
		    return { __html: rawMarkup};
		},
		replaceNull: function(_value){        
	        if(_value != null && _value != "" ){
	            return _value;
	        }else{
	            if(Object.prototype.toString.call(_value) == "[object Number]")
	        		return 0;
	        	else
	            	return "-";	              
	        }
	    },
    	render: function() {
    		var object = this;
                var checkboxClass = this.props.styledCheckBox ? "checkbox checkbox-styled" : "";
      		if(this.props.loading.status && !this.props.error.status){
      			return (
	      			React.createElement("tbody", null, 
		        		React.createElement("tr", null, 
		        			React.createElement("td", {className: "height-6", colSpan: this.props.loading.height, dangerouslySetInnerHTML: this.rawMarkup(this.props.loading.loadingText)}
		        			)
		        		)
		        	)
		        );
      		}else if(this.props.error.status && !this.props.loading.status){
      			return (
	      			React.createElement("tbody", null, 
		        		React.createElement("tr", null, 
		        			React.createElement("td", {className: "height-6 text-center", colSpan: this.props.error.height, dangerouslySetInnerHTML: this.rawMarkup(this.props.error.content)}
		        			)
		        		)
		        	)
		        );
      		}else{
      			if(this.props.data.length > 0){					
      				var columns = this.props.columns;
      				var rowId = this.props.rowId;
			      	if(this.props.multiple){
				      	var rows = this.props.data.map(function(row, index){
							var items = columns.map(function(column){
								var renderer = function(_value) {
						            return _value;
						        }

						        if (column.hasOwnProperty("maxWidth") && $.isNumeric(column.maxWidth)) {
			                        //htmlBody += "<td style='word-wrap: break-word;max-width:" + column.maxWidth +"px;' title='" + render(value, _item) +"'";
			                    }else{
			                        //htmlBody += "<td style='word-wrap: break-word;max-width:600px;' title='" + render(value, _item) +"'";
			                    }
								if ($.isFunction(column.renderer)) {
		                            renderer = column.renderer;
		                            if (column.hasOwnProperty("maxWidth") && $.isNumeric(column.maxWidth)) {
		                            	var tdStyle = {
										  wordWrap: 'break-word',
										  maxWidth: column.maxWidth + 'px'
										};
		                            	return ( 
											React.createElement("td", {className: "truncateTdReact", key: column.dataIndex, style: tdStyle, title: object.replaceNull(row[column.dataIndex]), dangerouslySetInnerHTML: { __html: renderer(object.replaceNull(row[column.dataIndex]), row, index)}})
										);
		                            }else{
		                            	return ( 
											React.createElement("td", {className: "truncateTdReact", key: column.dataIndex, dangerouslySetInnerHTML: { __html: renderer(object.replaceNull(row[column.dataIndex]), row, index)}})
										);
		                            }		                            
		                        }else{
		                        	var tdStyle = {
										  wordWrap: 'break-word'
									};

									if (column.hasOwnProperty("styleProperties")){										
										$.each(column.styleProperties,function(key, value){
											tdStyle[key] = value + " !important";
										});
									}

									return ( 
										React.createElement("td", {className: "truncateTdReact", key: column.dataIndex, style: tdStyle, title: object.replaceNull(row[column.dataIndex])}, renderer(object.replaceNull(row[column.dataIndex])))
									);		                        	
		                        }								
							})

                        if(styleCheck){
                        return(	 
                            React.createElement("tr", {key: row[rowId], id: row[rowId]}, 
                                    React.createElement("td", {className: "truncateTdReact"}, 
                                            React.createElement("div", {className: checkboxClass}, 
                                                    React.createElement("label", {className: "cbRow"}, 
                                                            React.createElement("input", {type: "checkbox", className: "ltableCheckbox", id: row[rowId]}), 
                                                            React.createElement("span", {id: "checkbox"})
                                                    )
                                            )
                                    ), 	
                                    items
                            )
                        )
                        }else{
                            return(	 
                                React.createElement("tr", {key: row[rowId], id: row[rowId]}, 
                                        React.createElement("td", {className: "truncateTdReact"}, 
                                            React.createElement("input", {type: "checkbox", className: "ltableCheckbox", id: row[rowId]})
                                        ), 	
                                        items
                                )
                            )
                        }
					      	
					    })
					}else{
						var rows = this.props.data.map(function(row, index){
							var items = columns.map(function(column){
								var renderer = function(_value) {
						            return _value;
						        }
								if ($.isFunction(column.renderer)) {
		                            renderer = column.renderer;
		                            if (column.hasOwnProperty("maxWidth") && $.isNumeric(column.maxWidth)) {
		                            	var tdStyle = {
										  wordWrap: 'break-word',
										  maxWidth: column.maxWidth + 'px'
										};
		                            	return ( 
											React.createElement("td", {key: column.dataIndex, className: "truncateTdReact", style: tdStyle, title: object.replaceNull(row[column.dataIndex]), dangerouslySetInnerHTML: { __html: renderer(object.replaceNull(row[column.dataIndex]), row, index)}})
										);
		                            }else{
		                            	return ( 
											React.createElement("td", {key: column.dataIndex, className: "truncateTdReact", dangerouslySetInnerHTML: { __html: renderer(object.replaceNull(row[column.dataIndex]), row, index)}})
										);
		                            }		                            
		                        }else{
		                        	var tdStyle = {
										  wordWrap: 'break-word'
									};

									if (column.hasOwnProperty("styleProperties")){										
										$.each(column.styleProperties,function(key, value){
											tdStyle[key] = value + " !important";
										});
									}

									return ( 
										React.createElement("td", {key: column.dataIndex, style: tdStyle, className: "truncateTdReact", title: object.replaceNull(row[column.dataIndex]), dangerouslySetInnerHTML: { __html: renderer(object.replaceNull(row[column.dataIndex]), row, index)}})
									);		                        	
		                        }
							})
					      	return(	 
					      		React.createElement("tr", {key: row[rowId], id: row[rowId]}, 	
					        		items
					        	)
					        )
					    })
					}
			        return (
				        React.createElement("tbody", null, 
				        	rows
				        )
			        );  
      			}else{
      				return (
				        React.createElement("tbody", {dangerouslySetInnerHTML: this.rawMarkup(this.props.emptyData.content)}
				        )
			        ); 
      			}
      			
      		}      	      
      	}
    });

var Tfoot = React.createClass({displayName: "Tfoot",  
	rawMarkup: function(content){
	    var rawMarkup = marked(content.toString(), {sanizite:true});
	    return { __html: rawMarkup};
	},
	replaceNull: function(_value, _column){
		var regularValue = function(value){
        	if(_value != null && _value != "" && _value.toString() != "NaN"){
				return _value;
			}else{
				if(Object.prototype.toString.call(_value) == "[object Number]")
					if( _value.toString() != "NaN")
						return 0;
					else
						return " ";
				else
					return " ";	              
			}
        }        
        if(_column.hasOwnProperty("showTotalTitle")){
        	if(_column.showTotalTitle)
				if(_column.hasOwnProperty("totalTitle"))
						if(window.loggedUser.initialDateLanguage == 'en'){
							return _column.totalTitle != "" ? _column.totalTitle : "Total";

						}else{
							return _column.totalTitle != "" ? _column.totalTitle : "Totales";

						}
				else
					if(window.loggedUser.initialDateLanguage == 'en'){
						return "Total";
					}else{
						return "Totales";
					}
        	else
        		return " ";
        }else{
        	if(_column.hasOwnProperty("showTotalValue"))
        		if(_column.showTotalValue){
        			return regularValue(_value);
        		}else
        			return "";
        	else
        		return regularValue(_value);
        }        
    },   
	render: function(){
		var totals = {};
		var object = this;
		var footerRows = [];
		var columns = this.props.columns;
		if(this.props.data.length > 0 && this.props.showFooter){
			$.each(this.props.data, function(index, value){
				$.each(value, function(key, keyValue){
					totals[key] = (Number(totals[key]).toString() == "NaN" ? 0 : Number(totals[key])) + 
								  (Number(keyValue).toString() == "NaN" ? 0 : Number(keyValue));
				});
			});	
			footerRows = [totals];
		    var rows = footerRows.map(function(row){
				var items = columns.map(function(column){
					var renderer = function(_value) {
						return _value;
					}
										
					return ( 
						React.createElement("td", {key: column.dataIndex, className: "text-footer truncateTdReact", title: object.replaceNull(row[column.dataIndex],column), dangerouslySetInnerHTML: {__html:renderer(object.replaceNull(row[column.dataIndex],column), row)}})
						
					);
				});
				return items;
			});	    
		    return (
	        	React.createElement("tfoot", null, 
	        		React.createElement("tr", {className: "style-default"}, 			        		
	        			rows
	        		)
	        	)
		    	);
		}else{
			return (React.createElement("tfoot", null));
		}
	}
});